import { useState, useEffect } from "react";
import LabelAndValue from "./LabelAndValue";

function StockInfo({ stock }) {
  const [price, setPrice] = useState(null);

  useEffect(() => {
    async function fetchPrice() {
      const value = await stock.getCurrentValue(); // Wait for the async function
      setPrice(value); // Store in state
    }
    fetchPrice();
  }, [stock]);

  return (
    <>
      <div className="stock-card">
        <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
          <h3>{stock.code}</h3>
          <h3>₱{(price*stock.shares).toLocaleString(2)}
            <span style={{color: (price >= stock.boughtValue ? "green" : "red")}}>
              ({(price >= stock.boughtValue ? "+" : "-")}₱{(Math.abs(price-stock.boughtValue)*stock.shares).toLocaleString(2)})
              </span>
          </h3>
        </div>
        <hr/>
        <div style={{display: "flex",  gap: "10px", justifyContent: "space-between"}}>
          <LabelAndValue label="Shares" value={stock.shares}/>
          <LabelAndValue label="Bought at" value={stock.boughtValue}/>
          <LabelAndValue label="Price" value={price?.toLocaleString(2) || ""}/>
        </div>
        
      </div>
    </>
    
  );
  
  
  
}

export default StockInfo;